export const LOCALFORAGE_DBNAME = 'SIMPLITPOS'
export const LOCALFORAGE_LOGIN = 'login'
export const LOCALFORAGE_ISOFFLINESTATION = 'isOfflineStation'